<script lang="ts" setup>
import { DropdownItem, Icon } from '@brighterly/lib-lumee-ui'

import { getContacts } from '@shared/config'
import { trackEvent } from '@shared/lib/amplitude'

import { useContactLaunchers } from './contact-launchers.hook'

defineOptions({
  name: 'LinkSendEmail',
})

const text = 'Send email'
const contacts = getContacts()

const {
  openEmail,
} = useContactLaunchers()

const setSubmit = (): void => {
  const options = {
    to: contacts.email,
    subject: 'Support request',
    body: '',
  }
  trackEvent('Link_click', { feature: 'support', name: 'send_email', text, channel: 'email' })
  openEmail(options)
}

</script>

<template>
  <DropdownItem
    :title="text"
    role="menuitem"
    :aria-selected="undefined"
    @click="setSubmit"
  >
    <template #leading>
      <Icon
        name="envelope"
        size="md"
        color="default"
      />
    </template>
  </DropdownItem>
</template>
